export type { TenantService } from './tenant.service'
export { TenantModule } from './tenant.module'
